export class PendingInvitation {
  constructor(
        public organizationId: string,
        public organizationName: string,
        public organizationOwnerName: string,
        public organizationOwnerEmail: string,
        public invitationTokenId: string
  ) {
  }
}